<template>
    <div>
        <div class="content-left">
            <h2>{{title}}</h2>
            <div class="content-left_text">
                <p
                    v-for="(nav,index) in navList"
                    :key="index"
                    :style="{'color':index==activeNav?'#237dc8':''}"
                    @click="getActive(index)"
                >
                    <i class="el-icon-arrow-right"></i>
                    {{nav}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    navList: Array,
    activeNav: String || Number,
    title: String,
    getActive: Function
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.content-left {
  width: 238px;
  h2 {
    padding: 20px 0 15px 10px;
    font-size: 20px;
    color: #237dc8;
  }
  .content-left_text {
    font-size: 14px;
    color: #666;
    p:nth-child(1) {
      border-top: 1px solid #dfdfdf;
    }
    p {
      padding: 10px 0;
      border-bottom: 1px solid #dfdfdf;
      cursor: pointer;
      &:hover {
        color: #237dc8;
      }
    }
    i {
      color: #237dc8;
    }
  }
}
</style>